














import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class RegisterButton extends Vue {
    @Prop() block?: boolean;

    public register() {
        // im auht0 web interface entsprechend angepasst
        // https://community.auth0.com/t/how-to-redirect-user-to-hosted-signup-page/9482
        this.$auth.loginWithRedirect({ mode: "signUp" });
    }
}
